/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { Box, Input, InputLabel } from "@mui/material";
import "./Updatecommunity.css";
import {
  updateCommunityApi,
  fetchCommunityDocName,
  fetchCommunityByCommunityId,
} from "../../Services/Community/CommunityAPI/communityApi";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import {
  CommunityOwner,
  GOOGLE_PLACES_API_KEY,
  SuperAdmin,
} from "../../Utils/Constant";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLoadScript, Autocomplete } from "@react-google-maps/api";
import { ThreeDot } from "react-loading-indicators";

const libraries = ["places"];

function UpdatecommunityComp() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [errors, setErrors] = useState({});
  const [applicationInputType, setApplicationInputType] = useState("url");
  const [eventInputType, setEventInputType] = useState("url");
  const [loading, setLoading] = useState(false);
  const [isApplicationInput, setIsApplicationInput] = useState(false);
  const [isEventInput, setIsEventInput] = useState(false);
  const { data } = useSelector((state) => state.communityById);

  const location = useLocation();
  const idFromState = location.state?.communityId; // Access the state passed
  const [autocomplete, setAutocomplete] = useState(null);
  const [inputValueAuto, setInputValueAuto] = useState(
    data?.data?.location?.city
  );

  useEffect(() => {
    setInputValueAuto(data?.data?.location?.city);
  }, [data?.data?.location?.city]);

  useEffect(() => {
    dispatch(fetchCommunityDocName());
  }, [dispatch]);

  // State for form inputs
  const [formData, setFormData] = useState({
    community_name: "",
    city: "",
    state: "",
    type: "",
    unit: "",
    doc_type: "",
    doc_type_name_id: "",
    owned_by: "",
    community_documents: null,
    map_url: "",
    application_url: "",
    application_doc: null,
    event_doc: null,
    event_url: "",
    place_id: "",
  });
  const user_type = localStorage.getItem("user_type");

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (idFromState) {
          const response = await dispatch(
            fetchCommunityByCommunityId(idFromState)
          ).unwrap();

          setFormData({
            community_name: response?.data?.community_name || "",
            city: response?.data?.location?.city || "",
            state: response?.data?.location?.state || "",
            place_id: response?.data?.location?.place_id || "",
            type: response?.data?.type || "",
            unit: response?.data?.unit || "",
            owned_by: response?.data?.owned_by,
            map_url: response?.data?.map_url || "",
            application_url: response?.data?.application_url || "",
            // application_doc: response?.data?.application_doc || "",
            // event_doc: response?.data?.event_doc || "",
            event_url: response?.data?.event_url || "",
          });

          if (response?.data?.application_doc) setApplicationInputType("doc");
          if (response?.data?.event_doc) setEventInputType("doc");

          setIsApplicationInput(!!response?.data?.application_doc);
          setIsEventInput(!!response?.data?.event_doc);
        }
      } catch (error) {
        console.error("Error fetching community data:", error);
      }
    };

    fetchData();
  }, [dispatch, idFromState]);

  const handleTypeChange = (e) => {
    const selectedType = e.target.value;
    setFormData((prevData) => ({
      ...prevData,
      type: selectedType,
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const validateForm = () => {
    const errors = {};

    if (!formData.community_name.trim()) {
      errors.community_name = "Community Name is required";
    }
    if (!formData.state) {
      errors.state = "State is required";
    }
    if (!formData.city) {
      errors.city = "City is required";
    }

    setErrors(errors); // Update error state

    return Object.keys(errors).length === 0; // Return true if no errors
  };

  console.log("formData", formData);

  const handleSubmit = (e) => {
    e.preventDefault();
    const isValid = validateForm();

    if (!isValid) {
      return;
    }
    setLoading(true);

    const formDataToSubmit = new FormData();
    formDataToSubmit.append("community_name", formData.community_name);
    formDataToSubmit.append("community_city", formData.city);
    formDataToSubmit.append("community_state", formData.state); // Send state name
    formDataToSubmit.append("type", formData.type);
    formDataToSubmit.append("unit", formData.unit);
    formDataToSubmit.append("owned_by", formData.owned_by);
    formDataToSubmit.append("map_url", formData.map_url);
    formDataToSubmit.append("place_id", formData.place_id);

    if (applicationInputType === "url") {
      formDataToSubmit.append("application_url", formData.application_url);
    } else if (
      applicationInputType === "doc" &&
      formData.application_doc &&
      typeof formData.application_doc !== "string"
    ) {
      formDataToSubmit.append("application_doc", formData.application_doc);
    } else if (
      applicationInputType === "doc" &&
      !formData.application_doc &&
      typeof formData.application_doc === "string"
    ) {
      formDataToSubmit.append("application_doc", "");
    }

    if (eventInputType === "url") {
      formDataToSubmit.append("event_url", formData.event_url);
    } else if (
      eventInputType === "doc" &&
      formData.event_doc &&
      typeof formData.event_doc !== "string"
    ) {
      formDataToSubmit.append("event_doc", formData.event_doc);
    } else if (
      eventInputType === "doc" &&
      !formData.event_doc &&
      typeof formData.event_doc === "string"
    ) {
      formDataToSubmit.append("event_doc", "");
    }

    dispatch(
      updateCommunityApi({
        communityId: idFromState,
        formData: formDataToSubmit,
      })
    )
      .unwrap()
      .then((res) => {
        toast.success("Community Updated successfully!");
        if (user_type === CommunityOwner) {
          setTimeout(() => {
            navigate("/admin/Admin-community");
          }, 1000);
        }
        if (user_type === SuperAdmin) {
          setTimeout(() => {
            navigate("/super-admin/super-admin-community-comp");
            setLoading(false);
          }, 1000);
        }
      })
      .catch((err) => {
        toast.error("Community Update failed!");
        setLoading(false);
      });
  };

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: GOOGLE_PLACES_API_KEY, // Replace with your actual API key
    libraries,
  });

  const onLoad = (autocompleteInstance) => {
    setAutocomplete(autocompleteInstance);
  };

  const onPlaceChanged = () => {
    if (autocomplete) {
      const place = autocomplete.getPlace();

      setInputValueAuto(place.formatted_address || place.name);

      const placeId = place.place_id;
      const addressComponents = place.address_components || [];
      const cityComponent = addressComponents.find((component) =>
        component.types.includes("locality")
      );
      const stateComponent = addressComponents.find((component) =>
        component.types.includes("administrative_area_level_1")
      );

      const city = cityComponent?.long_name || "";
      const state = stateComponent?.short_name || "";

      if (city) {
        setFormData((prevData) => ({
          ...prevData,
          city: city,
          state: state,
          place_id: placeId,
        }));
      }
    }
  };

  if (!isLoaded) {
    return (
      <div>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh",
            flexDirection: "column",
            textAlign: "center",
          }}
        >
          <ThreeDot color="#dd483b" size="medium" text="" textColor="" />
        </Box>
      </div>
    );
  }

  return (
    <>
      <div className="back-btn">
        <button onClick={() => navigate(-1)} className="back-btn-button">
          {/* <img src={chevronleft} alt="chevron-left" className="left-icon" />
           */}
          <ArrowBackIcon className="left-icon" />
          Back
        </button>
      </div>
      <div className="community-section">
        <div className="community-inner-wrap">
          <div className="add-new-community d-flex justify-content-between align-items-center">
            <div className="community-heading create-new">Update Community</div>
          </div>
          <div className="create-community-name-table">
            <div className="create-comm-inner-wrap">
              <form className="create-community-form">
                {/* Community Name */}
                <div className="main-community-block">
                  <div className="d-flex align-items-center community-city-blk">
                    <div className="comm-name-blk">
                      <InputLabel htmlFor="community-name">
                        Community Name
                      </InputLabel>
                      <Input
                        id="community_name"
                        className="input-box"
                        placeholder="Enter community name"
                        type="text"
                        name="community_name"
                        value={formData.community_name}
                        onChange={handleInputChange}
                      />
                      {errors.community_name && (
                        <div className="error-text">
                          {errors.community_name}
                        </div>
                      )}
                    </div>

                    {/* City */}
                    <div className="comm-name-blk">
                      <InputLabel htmlFor="city">City</InputLabel>
                      <Autocomplete
                        onLoad={onLoad}
                        onPlaceChanged={onPlaceChanged}
                        options={{
                          types: ["(cities)"],
                          componentRestrictions: { country: "us" },
                        }}
                      >
                        <Input
                          type="text"
                          placeholder="Type City..."
                          value={inputValueAuto}
                          onChange={(e) => setInputValueAuto(e.target.value)}
                          style={{
                            width: "100%",
                            // padding: "8px",
                            fontSize: "16px",
                            borderRadius: "20px",
                          }}
                        />
                      </Autocomplete>
                      {errors.city && (
                        <div className="error-text">{errors.city}</div>
                      )}
                    </div>
                  </div>

                  <div className="state-type-unit-blk d-flex align-items-center">
                    {/* Type */}
                    <div className="mb-4">
                      <InputLabel htmlFor="type">Type</InputLabel>
                      <select
                        id="type"
                        name="type"
                        className="dropdown-box"
                        value={formData.type}
                        onChange={handleTypeChange}
                      >
                        <option value="" disabled selected>
                          Select type
                        </option>
                        <option value="HOA">HOA</option>
                        <option value="COA">COA</option>
                        <option value="Co-op">Co-op</option>
                        <option value="Mobile Park">Mobile Park</option>
                        <option value="Timeshare">Timeshare</option>
                      </select>
                      {errors.type && (
                        <div className="error-text">{errors.type}</div>
                      )}
                    </div>

                    {/* Units */}
                    <div className="">
                      <InputLabel htmlFor="unit">Units</InputLabel>
                      <Input
                        id="unit"
                        className="input-box"
                        placeholder="Enter units"
                        type="number"
                        name="unit"
                        value={formData.unit}
                        onChange={handleInputChange}
                      />
                      {errors.unit && (
                        <div className="error-text">{errors.unit}</div>
                      )}
                    </div>
                  </div>
                  <div className="d-flex align-items-start community-city-blk upload-app-block">
                    <div className="comm-name-blk">
                      <InputLabel htmlFor="map_url">Map URL</InputLabel>
                      <Input
                        id="map_url"
                        className="input-box"
                        placeholder="Enter Map URL"
                        type="text"
                        name="map_url"
                        value={formData.map_url}
                        onChange={handleInputChange}
                      />
                      {errors.map_url && (
                        <div className="error-text">{errors.map_url}</div>
                      )}
                    </div>
                  </div>
                  <div className="d-flex upload-app-block mb-4">
                    <div className="form-group input-type-url">
                      <label htmlFor="applicationInputType">
                        Application Input Type:
                      </label>
                      <div>
                        <div className="d-flex flex-column mt-2">
                          <label>
                            <input
                              type="radio"
                              name="applicationInputType"
                              value="url"
                              className="me-2"
                              checked={applicationInputType === "url"}
                              onChange={(e) => {
                                setApplicationInputType(e.target.value);
                              }}
                            />
                            URL
                          </label>
                          <label>
                            <input
                              type="radio"
                              name="applicationInputType"
                              value="doc"
                              className="me-2"
                              checked={applicationInputType === "doc"}
                              onChange={(e) => {
                                setApplicationInputType(e.target.value);
                              }}
                            />
                            Upload Document
                          </label>
                        </div>
                      </div>
                    </div>
                    {applicationInputType === "url" ? (
                      <div className="form-group mt-2 url-blk">
                        <label htmlFor="application_url" className="d-block">
                          Application URL
                        </label>
                        <input
                          type="text"
                          name="application_url"
                          value={formData.application_url}
                          onChange={handleInputChange}
                        />
                      </div>
                    ) : (
                      <div className="form-group upload-app-document">
                        <label
                          className="custom-upload-btn d-block"
                          htmlFor="application_doc"
                        >
                          Upload Application Document
                        </label>
                        {!isApplicationInput ? (
                          <input
                            type="file"
                            id="application_doc"
                            name="application_doc"
                            accept=".pdf,.doc,.docx"
                            className="upload-app-doc"
                            onChange={(e) => {
                              // if (!data?.data?.application_doc)
                              setFormData((prev) => ({
                                ...prev,
                                application_doc: e.target.files[0],
                              }));
                            }}
                          />
                        ) : (
                          <div className="upload-text">
                            {" "}
                            Uploaded Document :{" "}
                            <a
                              href={data?.data?.application_doc}
                              target="_blank"
                              rel="noreferrer"
                              className="orange-filled-btn claimbtn mx-2"
                            >
                              View
                            </a>
                            <button
                              // href=""
                              // target="_blank"
                              // rel="noreferrer"
                              className="orange-filled-btn claimbtn"
                              type="button"
                              onClick={() => {
                                setIsApplicationInput(false);
                                setFormData((prev) => ({
                                  ...prev,
                                  application_doc: "",
                                }));
                              }}
                            >
                              Remove
                            </button>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  <div className="d-flex upload-app-block">
                    <div className="form-group input-type-url">
                      <label htmlFor="eventInputType">Event Input Type:</label>
                      <div>
                        <div className="d-flex flex-column mt-2">
                          <label>
                            <input
                              type="radio"
                              name="eventInputType"
                              value="url"
                              className="me-2"
                              checked={eventInputType === "url"}
                              onChange={(e) => {
                                setEventInputType(e.target.value);
                              }}
                            />
                            URL
                          </label>
                          <label>
                            <input
                              type="radio"
                              name="eventInputType"
                              value="doc"
                              className="me-2"
                              checked={eventInputType === "doc"}
                              onChange={(e) => {
                                setEventInputType(e.target.value);
                              }}
                            />
                            Upload Document
                          </label>
                        </div>
                      </div>
                    </div>

                    {eventInputType === "url" ? (
                      <div className="form-group mt-2 url-blk">
                        <label htmlFor="event_url" className="d-block">
                          Event URL
                        </label>
                        <input
                          type="text"
                          name="event_url"
                          value={formData.event_url}
                          onChange={handleInputChange}
                        />
                      </div>
                    ) : (
                      <div className="form-group upload-app-document">
                        <label
                          className="custom-upload-btn d-block"
                          htmlFor="event_doc"
                        >
                          Upload Event Document
                        </label>
                        {!isEventInput ? (
                          <input
                            type="file"
                            id="event_doc"
                            name="event_doc"
                            accept=".pdf,.doc,.docx"
                            className="upload-app-doc"
                            onChange={(e) => {
                              // if (!data?.data?.event_doc)
                              setFormData((prev) => ({
                                ...prev,
                                event_doc: e.target.files[0],
                              }));
                            }}
                          />
                        ) : (
                          <div className="upload-text">
                            {" "}
                            Uploaded Document :{" "}
                            <a
                              href={data?.data?.event_doc}
                              target="_blank"
                              rel="noreferrer"
                              className="orange-filled-btn claimbtn mx-2"
                            >
                              View
                            </a>
                            <button
                              // href=""
                              // target="_blank"
                              // rel="noreferrer"
                              className="orange-filled-btn claimbtn "
                              type="button"
                              onClick={() => {
                                setIsEventInput(false);
                                setFormData((prev) => ({
                                  ...prev,
                                  event_doc: "",
                                }));
                              }}
                            >
                              Remove
                            </button>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </form>
            </div>
            <div className="create-comm-btn">
              <button
                type="submit"
                className="orange-filled-btn"
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? "Updating..." : "Update Community"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UpdatecommunityComp;
